<template>
  <div v-if="!this.loading" class="animated fadeIn">
    <tableDinamic :items="this.dataLoad.items" :fields="this.dataLoad.fields" :methodsTable="this.dataLoad.methodsTable"></tableDinamic>
  </div>
</template>
<script>
import tableDinamic from '@/views/base/table/Table.vue'
// import { mapGetters } from 'vuex'
export default {
  name: 'Lists',
  components: {
    tableDinamic
  },
  data () {
    return {
      loading: true,
      form: {},
      dataLoad: {}
    }
  },
  mounted () {
    this.$store.dispatch('inventoryReportsAll').then((response) => {
      this.dataLoad = this.$store.getters['inventoryReports']
      this.loading = false
    }).catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/inventory/reports/list.vue